<!--  -->
<template>
  <div>
    <div class="froms">
      <div class="title">欢迎注册Pkbeds账号</div>
      <div class="tips">我们在您提交注册信息后24小时内会进行信息核对，届时请您留意注册激活邮件。</div>
      <div class="step">
        <div class="step1">
          <div class="red">1</div>
          <div class="tips_min">注册填写</div>
        </div>
        <div class="step2">
          <div class="red red_no">2</div>
          <div class="tips_min">信息审核</div>
        </div>
      </div>
      <div class="title2">机构信息已提交审核</div>
      <div class="tips">感谢您注册成为Pkbeds用户，您提交的机构信息审核通过即可登录</div>
    </div>
    <div class="btn" @click="shouye">确定</div>
    <div class="bto">
      <!-- <fottom></fottom> -->
    </div>
  </div>
</template>

<script>
import fottom from '@/components/fottom.vue'
export default {
  data() {
    return {

    };
  },
  components: {
    fottom
  },

  computed: {},

  mounted() { },

  methods: {
    shouye() {
      this.$router.push('/')
    }
  }
}

</script>
<style scoped>
.btn {
  width: 228px;
  height: 56px;
  background-image: #3a479d;
  border-radius: 39px;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 56px;
  margin: auto;
  margin-top: 30px;
  cursor: pointer;
}

.froms {
  width: 588px;
  margin: auto;
  margin-top: 80px;
  padding-top: 1px;
  box-sizing: border-box;
}

.title {
  font-weight: 600;
  font-size: 40px;
  color: #000000;
}

.tips {
  font-weight: 400;
  font-size: 16px;
  color: #686F86;
  margin-top: 10px;
}

.step {
  width: 484px;
  /* display: flex;
  justify-content: space-between; */
  border-top: 2px solid #37B889;
  position: relative;
  margin-top: 30px;
  margin-left: 68px;
}

.step1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: -11px;
  left: -22px;
}

.step2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: -11px;
  right: -22px;
}

.red {
  width: 22px;
  height: 22px;
  background: #37B889;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 22px;
  border-radius: 50%;
}

.red_no {
  background: #37B889;
  color: #FFFFFF;
}

.tips_min {
  font-weight: 400;
  font-size: 14px;
  color: #686F86;
  margin-top: 5px;
}

.title2 {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  margin-top: 50px;
  margin-bottom: 16px;
}

.bto {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>